export const today = () => new Date().toISOString().split("T")[0];

export const fmtDate = (d) => {
  if (d === null || d === undefined || d === "") return "—";

  let value = d;
  if (typeof d === "string" && /^-?\d+$/.test(d.trim())) {
    value = Number(d);
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
export const avatarChar = (b) =>
  (b?.businessname || b?.firstname || "?")[0].toUpperCase();

export const avatarBg = (seed = "") => {
  const hues = [220, 260, 320, 30, 160, 190, 280, 50];
  let h = 0;
  for (const c of seed) h = (h + c.charCodeAt(0)) % hues.length;
  return `hsl(${hues[h]}, 60%, 50%)`;
};

export const planTypeLabel = (v) =>
  ({ 0: "Free", 1: "Basic", 2: "Pro", 3: "Enterprise" }[v] ?? `Type ${v}`);

export const defaultUsageForm = () => ({
  startdate: today(),
  enddate: "",
  trialplanenddate: "",
  curruntplanid: "",
  plantype: 0,
  isfreeplan: false,
  isfullaccess: false,
  isactive: true,
  paymentid: "",
  subscriptionid: "",
  locationid: "",
  trialplanid: "",
  deleted: false,
  // limits
  userslimit: 1,
  textsmslimit: 100,
  emaillimit: 15000,
  storagelimit: 5,
  calltimelimit: 0,
  leadgatheringlimit: 100,
  socialpostlimit: 50,
  emailfinderlimit: 100,
  leadfinderlimit: 100,
  aiquerylimit: 100,
  enrichsearchlimit: 5,
  enrichreveallimit: 5,
  // unlimited
  isunlimitedusers: false,
  isunlimitedtextsms: false,
  isunlimitedemail: false,
  isunlimitedstorage: false,
  isunlimitedcalltime: false,
  isunlimitedleadgathering: true,
  isunlimitedsocialpost: false,
  isunlimitedemailfinder: false,
  isunlimitedleadfinder: false,
  isunlimitedaiquery: false,
  // usage counters (single only)
  users: 0, textsms: 0, email: 0, storage: 0, calltime: 0,
  leadgathering: 0, socialpost: 0, emailfinder: 0, leadfinder: 0,
  aiquery: 0, linkedinuser: 0, whatsappuser: 0, enrichsearch: 0, enrichreveal: 0,
  // multiple only
  planinterval: 1,
});

export const LIMIT_FIELDS = [
  { key: "userslimit", label: "Users", unlimitedKey: "isunlimitedusers", usageKey: "users", icon: "👤" },
  { key: "textsmslimit", label: "SMS", unlimitedKey: "isunlimitedtextsms", usageKey: "textsms", icon: "💬" },
  { key: "emaillimit", label: "Email", unlimitedKey: "isunlimitedemail", usageKey: "email", icon: "📧" },
  { key: "storagelimit", label: "Storage (GB)", unlimitedKey: "isunlimitedstorage", usageKey: "storage", icon: "💾" },
  { key: "calltimelimit", label: "Call Time (min)", unlimitedKey: "isunlimitedcalltime", usageKey: "calltime", icon: "📞" },
  { key: "leadgatheringlimit", label: "Contacts", unlimitedKey: "isunlimitedleadgathering", usageKey: "leadgathering", icon: "🎯" },
  { key: "socialpostlimit", label: "Social Posts", unlimitedKey: "isunlimitedsocialpost", usageKey: "socialpost", icon: "📱" },
  { key: "emailfinderlimit", label: "Email Finder", unlimitedKey: "isunlimitedemailfinder", usageKey: "emailfinder", icon: "🔍" },
  { key: "leadfinderlimit", label: "Lead Finder", unlimitedKey: "isunlimitedleadfinder", usageKey: "leadfinder", icon: "📋" },
  { key: "aiquerylimit", label: "AI Queries", unlimitedKey: "isunlimitedaiquery", usageKey: "aiquery", icon: "🤖" },
  { key: "linkedinuserlimit", label: "LinkedIn Users", usageKey: "linkedinuser", icon: "💼" },
  { key: "whatsappuserlimit", label: "WhatsApp Users", usageKey: "whatsappuser", icon: "💬" },
{ key: "instagramuserlimit", label: "Instagram Users", usageKey: "instagramuser", icon: "📸" },
  { key: "enrichsearchlimit", label: "Enrich Search", usageKey: "enrichsearch", icon: "🔎" },
  { key: "enrichreveallimit", label: "Enrich Reveal", usageKey: "enrichreveal", icon: "✨" },
];
